var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKlugoLogoOriginal = function SvgKlugoLogoOriginal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 743.6 126.8",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-603.65 -759.898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m833.1 759.9-44.3 45.3v-45.3h-22.7v126.7h22.8v-52l.8-.8 43.1 52.8h30.4L806 818.1l58.1-58.1-31-.1z",
    style: {
      fill: "#0a1343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.3 759.9h-22.8v126.7h57.2v-21.8h-34.4V759.9z",
    style: {
      fill: "#0a1343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.2 840.2v-80.3h-22.9v75.5c0 9.6-1.5 16.5-4.4 20.5-4.4 6-10.6 9-18.7 9-8 0-14.2-2.9-18.6-8.9-2.9-4.2-4.4-11.1-4.4-20.6v-75.5h-22.8v80.3c0 13 4.1 23.8 12.3 32.3 9 9.4 20.4 14.2 33.6 14.2 13.2 0 24.6-4.7 33.7-14.2 8-8.5 12.2-19.3 12.2-32.3z",
    style: {
      fill: "#0a1343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.8 840.1h28.8c-1.3 6.3-4.6 11.9-10.3 16.7-6.5 5.5-13.6 8.1-21.7 8.1-9.6 0-18.5-3.7-26.6-11.1-8.8-8-13.2-17.9-13.2-30.3 0-12.1 3.8-21.7 11.9-29.8 7.9-8.1 17.5-12.1 29.4-12.1 13.1 0 23.8 5.9 33 18.1l1.7 2.3 16.4-15.7-1.6-1.8c-7.5-8.6-15.3-15-23.2-18.8-8.3-3.9-17.5-5.9-26.7-5.8-17.7 0-32.9 6.2-45.1 18.6-12.4 12.3-18.6 27.4-18.6 45 0 17.3 6.1 32.3 18.3 44.5 12.2 12.2 26.9 18.5 43.9 18.5 17.5 0 32.1-6.4 43.4-19.2 4.8-5.3 8.5-11.7 10.8-18.5v-.1c2.1-6.9 3.2-15.1 3.2-24.1v-6.4h-53.5l-.3 21.9z",
    style: {
      fill: "#0a1343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.6 870.3c12.5 10.9 26.7 16.3 42.4 16.3 17.7 0 33-6.2 45.5-18.4s18.8-27.2 18.8-44.6c0-17.4-6.3-32.5-18.7-44.8s-27.3-18.7-44.6-18.7c-17.5 0-32.7 6.2-45.1 18.5-11.7 11.5-18 25.1-18.8 40.7h-.1v3.6c-.2 19.4 6.8 35.3 20.6 47.4zm2.2-47.6c.1-11.6 3.9-21 11.9-29 7.9-8 17.4-12 29.1-12 11.6 0 21.1 3.9 29 12 7.9 8 11.8 17.7 11.8 29.6 0 11.8-3.9 21.4-11.9 29.6-8 8-17.6 12-29.3 12-10.6 0-20-3.9-28.2-11.8s-12.3-17.7-12.3-30.1l-.1-.3z",
    style: {
      fill: "#0a1343"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc286",
    d: "m46.5 63.3 57.7 20.1-68.3 39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00e693",
    d: "m35.9 3.5 68 39.5-57.4 20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2300e2",
    d: "M46.5 63.3.1 103.1V23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 63.2c-.2-12.9-11-23.8-23.8-23.1-6.4.3-9 1.8-15.1 5.4-2.7 1.6-23.3 13.5-30.7 17.7 7.2 4.1 28.7 16.6 30.7 17.7 6 3.6 8.6 5.1 15.1 5.4 12.9.6 23.7-10.1 23.8-23.1 0-.1 0 0 0 0z",
    fill: "#00af4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7 3C.6 9.5-3.4 24.4 3.6 35.2c3.5 5.4 6.1 6.9 12.3 10.4 2.7 1.5 23.3 13.4 30.7 17.7 0-8.3.1-33.1.1-35.4.1-7 .1-10.1-2.8-15.8C37.8.6 22.9-3.3 11.7 3z",
    fill: "#000082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 123.5c11.3 6.3 26 2.3 31.9-9 2.9-5.7 2.9-8.7 2.8-15.8 0-3.1-.1-26.8-.1-35.4-7.1 4.1-28.7 16.5-30.7 17.6-6.1 3.4-8.7 4.9-12.3 10.4-6.9 10.9-2.9 25.7 8.4 32.2z",
    fill: "#230077"
  })))));
};
export default SvgKlugoLogoOriginal;